<app-mid-right-panel [title]="'ORGANIZATION_SETTINGS.CHANGE_LOGO' | translate">
  <app-mid-right-panel-content>
    <div class="d-flex justify-content-center pt-3 pb-3 mt-2">
      <input type="file" (change)="SendLogo($event.target.files)" />
    </div>
  </app-mid-right-panel-content>
</app-mid-right-panel>
